export enum EOutlinesStyle {
    COLOR,
    BLACK_AND_WHITE,
    NO_OUTLINES
}
